import LTR from "@brand-icons/ploom/ui-upload/ui-upload-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiUploadIcon = iconFactory("UiUploadIcon", LTR);
